exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ndiv.tools ul.dropdown-menu {\n  max-height: 420px;\n  min-width: 280px;\n  overflow-y: auto;\n  max-width: 400px;\n}\n", ""]);

// exports
